import { DesktopHeader } from "molecules/navigation/desktop-header/DesktopHeader";
import { useFeatureFlag } from "services/Flags";

/**
 * The loading cover is position-fixed to the viewport, which is wider than the phone frame.
 * Keep the page itself in that frame when the desktop experience is off, or the loading page
 * paints the full window and then snaps back to the app.
 */
export const loadingPageColumnClass = (isDesktopExperience: boolean) =>
  isDesktopExperience ? "w-full" : "w-full sm:w-[390px]";

/**
 * Covers the page while a route loads. It paints over the app's own desktop header, so it carries
 * that header itself: the placeholder then sits exactly where the page will, sticky offsets included.
 */
export const PendingRouteViewport = ({ children }: { children: React.ReactNode }) => {
  const isDesktopExperience = useFeatureFlag("desktopExperience");

  return (
    <div className="fixed inset-0 z-30 flex justify-center overflow-y-auto bg-white pb-[calc(59px_+_env(safe-area-inset-bottom))] desk:pb-0">
      <div className={loadingPageColumnClass(isDesktopExperience)}>
        {isDesktopExperience && <DesktopHeader />}
        {children}
      </div>
    </div>
  );
};
